import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/error.svg'


const _hoisted_1 = { class: "notificationsView" }
const _hoisted_2 = { class: "mainTitle withArrow" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_arrow-L icon" }, null, -1)
const _hoisted_4 = { class: "filters" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "errorEmpty"
}
const _hoisted_7 = ["alt"]
const _hoisted_8 = {
  key: 1,
  class: "notifications"
}
const _hoisted_9 = { class: "content" }
const _hoisted_10 = {
  key: 0,
  class: "category"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = {
  key: 0,
  class: "time"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InfinityScroll = _resolveComponent("InfinityScroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "arrowBack",
        to: { name: 'FeedbackDashboard' }
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createTextVNode(" " + _toDisplayString(_ctx.$t("tell_city_view.feedbacks")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feedbackTypes, (type) => {
        return (_openBlock(), _createElementBlock("button", {
          key: type.id,
          class: _normalizeClass({ selected: type === _ctx.selectedType }),
          onClick: ($event: any) => (_ctx.selectType(type))
        }, _toDisplayString(_ctx.$t(`feedback.${type.name}`)), 11, _hoisted_5))
      }), 128))
    ]),
    (_ctx.feedbacks.data.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("img", {
            src: _imports_0,
            class: "error",
            alt: _ctx.$t('accessibility.error')
          }, null, 8, _hoisted_7),
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("feedback.empty_feedbacks")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("feedback.empty_feedback_list")), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.feedbacks.data.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_InfinityScroll, {
            onLoadNextPage: _ctx.getFeedbacks,
            data: _ctx.feedbacks,
            loading: _ctx.isLoading
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feedbacks.data, (feedback) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "notification",
                  key: feedback.id
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    (feedback.type)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString(_ctx.$t(`feedback.${feedback.type.name}`)), 1))
                      : _createCommentVNode("", true),
                    _hoisted_11,
                    (feedback.title)
                      ? (_openBlock(), _createElementBlock("h3", _hoisted_12, _toDisplayString(feedback.title), 1))
                      : (_openBlock(), _createElementBlock("h3", _hoisted_13, [
                          _createElementVNode("em", null, _toDisplayString(_ctx.$t("feedback.no_title")), 1)
                        ])),
                    (feedback.description)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(feedback.description), 1))
                      : _createCommentVNode("", true),
                    (feedback.image_url)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 4,
                          class: "feedbackImage",
                          src: feedback.image_url,
                          alt: _ctx.$t('accessibility.feedback.feedback_image')
                        }, null, 8, _hoisted_15))
                      : _createCommentVNode("", true)
                  ]),
                  (feedback.time)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$moment(feedback.time).format("DD.MM.YYYY HH:mm")), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["onLoadNextPage", "data", "loading"])
        ]))
      : _createCommentVNode("", true)
  ]))
}